import { GET_USER, GET_USERS_SUCCESS, GET_USERS_ERROR} from './actionTypes';

export const getUsers = (user) => {
    return {
        type: GET_USER,
        payload: { user }
    }
}

export const getUsersSuccess = (users, message) => {
    return {
        type: GET_USERS_SUCCESS,
        payload: {users, message}
    }
}

export const getUsersError = (user) => {
    return {
        type: GET_USERS_ERROR,
        payload: user
    }
}
